/**
 * 动画插值使用的预设缓动标识（固定枚举，禁止自由曲线）。
 */
export type EasingPreset =
  | 'linear'
  | 'ease-in'
  | 'ease-out'
  | 'ease-in-out'
  | 'bounce-out'
  | 'back-out'

/**
 * 所有支持的预设顺序（供下拉与校验）。
 */
export const EASING_PRESETS: readonly EasingPreset[] = [
  'linear',
  'ease-in',
  'ease-out',
  'ease-in-out',
  'bounce-out',
  'back-out',
] as const

/**
 * @param value - 任意字符串（如 JSON 反序列化）
 * @returns 是否为合法预设
 */
export function isEasingPreset(value: unknown): value is EasingPreset {
  return typeof value === 'string' && (EASING_PRESETS as readonly string[]).includes(value)
}
